.natural-breakpoint-finder-container {
    position: absolute;
    top: -9999;
    left: -9999;
    visibility: hidden;
    /* Ensure container shrink-wraps its content for accurate measurement */
    display: inline-flex;
}

.control-bar-container {
}

.control-bar-container--no-bg button:hover,
.control-bar-container--no-bg button:focus {
    background-color: transparent !important;
}
